import {
  DashboardOutlined,
  SettingOutlined,
  UserOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

// Resource constants (must match backend)
export const RESOURCES = {
  DASHBOARD: 'dashboard',
  USERS: 'users',
  DOCUMENTS: 'documents',
  BACKUPS: 'backups',
  MEMBERS: 'members',
};

// Dashboard
const dashboardNavTree = [{
  key: 'dashboard',
  path: `${APP_PREFIX_PATH}/dashboard`,
  title: 'Dashboard',
  icon: DashboardOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-dashboard',
      path: `${APP_PREFIX_PATH}/dashboard`,
      title: 'Dashboard',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DASHBOARD, action: 'read' }
    },
  ]
}];

// Membership management
const membershipNavTree = [{
  key: 'membership',
  path: `${APP_PREFIX_PATH}/membership`,
  title: 'Membership',
  icon: TeamOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-members',
      path: `${APP_PREFIX_PATH}/membership/members`,
      title: 'Members',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.MEMBERS, action: 'read' }
    },
  ]
}];

// Administration group - super admin only
const adminNavTree = [{
  key: 'administration',
  path: `${APP_PREFIX_PATH}/admin`,
  title: 'Administration',
  icon: SettingOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'app-users',
      path: `${APP_PREFIX_PATH}/admin/users`,
      title: 'User Management',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: [],
      adminOnly: true,
    },
  ]
}];

const navigationConfig = [
  ...dashboardNavTree,
  ...membershipNavTree,
  ...adminNavTree,
]

export default navigationConfig;
